import { PackageWithAdditionalInfo } from 'lib/const/PackageAdditionalInfo';
import { theme } from 'lib/style';
import React from 'react';
import styled from 'styled-components/macro';
import { Card } from '.';

const Wrapper = styled.div`
  margin-top: 32px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap;
  ${theme.mediaQueryMaxWidth.mb} {
    justify-content: center;
  }
`;

type Props = {
  packages: PackageWithAdditionalInfo[];
  billingCycle: string;
  onContactUs: (packageTitle: string) => void;
  currentPackage: number;
  onClickPackage: (id: number, cancel?: boolean) => void;
};
export const Layout = ({
  packages,
  billingCycle,
  onContactUs,
  currentPackage,
  onClickPackage,
}: Props) => {
  return (
    <Wrapper>
      {packages.map((packageDetails, i) => {
        if (packageDetails.isHidden) {
          return <></>;
        }
        return (
          <Card
            key={i}
            packageDetails={packageDetails}
            currentPackage={currentPackage}
            onClickPackage={onClickPackage}
            billingCycle={billingCycle}
            onContactUs={onContactUs}
          />
        );
      })}
    </Wrapper>
  );
};
